import { render, staticRenderFns } from "./examineeScore.vue?vue&type=template&id=6b801520&scoped=true"
import script from "./examineeScore.vue?vue&type=script&lang=js"
export * from "./examineeScore.vue?vue&type=script&lang=js"
import style0 from "./examineeScore.vue?vue&type=style&index=0&id=6b801520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b801520",
  null
  
)

export default component.exports